import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Accommodation = () => {
  const show=false;
  if(show)
  {
    
    return (
      <React.Fragment>
        <SEO title="Accommodation | ICSI 2023" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"
        />
  
        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h3 align="center" className="STYLE3">
              Reserving a Room at Venue Hotel{" "}
              <a href="http://www.lanhai.cn/fHotel/hotelIntroduce?id=11221">
                Qingdao Blue Horizon Hotel Laoshan (青岛蓝海大饭店（崂山）){" "}
              </a>
              !
            </h3>
            <p align="left">
              <br />
              1. All participants are highly recommendated to make a reservation
              at Qingdao Blue Horizon Hotel Laoshan in Qingdao.
              <br />
              2.Considering July is a tourism-peak season of Qingdao, it&apos;s
              may hard for you to find an available accommodation with reasonable
              price nearby the venue hotel, the secretariat offers our
              participants a reservation service.
              <br />
              3. We highly recommend our participants make your reservation ASAP
              before July 9th 23:59:59 GMT+8! It is very convenient for you to
              attend our technical/social acitvities during the confenerce.
              <br />
              4. We provide an official WeChat group for participants to
              communicate, if you are looking for a roommate during conference,
              please scan the following QR code.
              <br />
              <p align="center">
                <img src="./wechat.jpg" alt="" width="200px" />
              </p>
            </p>
  
            <div className="entry-content">
              <h4>
                <b>
                  More about accommodation: Please download the{" "}
                  <a href="./酒店简介.pdf" target="_blank">
                    hotel introduction.
                  </a>
                </b>
              </h4>
              <br></br>
              <p>
                Blue Horizon Hotel (Qingdao Shilaoren International Exhibition
                Center store) is affiliated to Shandong Blue Horizon Hotel Group,
                located in Laoshan District, Qingdao City, and shilao tourist
                resort in the south. It is an important part of Shandong
                International Conference and Exhibition Center. The rooms are
                distributed on the 3rd to 9th floors, with spacious and bright
                rooms, equipped with complete equipment such as broadband network,
                satellite TV, international direct dial telephone, small bar,
                electronic safe, etc., and equipped with transparent toilet and
                modern home facilities, showing luxury and fashion. It is an ideal
                choice for you to stay in business and life.
              </p>
              <div className="row">
                <img src="http://www.lanhai.cn/LHJD/outImages/hotel/20201118155129024_2304754.jpg" />
                <img src="http://www.lanhai.cn/LHJD/outImages/hotel/20170223140051718_6829513.jpg" />
                <img src="http://www.lanhai.cn/LHJD/outImages/hotel/20170223140004328_9545455.jpg" />
                <img src="http://www.lanhai.cn/LHJD/outImages/hotel/20170223135426890_467185.jpg" />
              </div>
            </div>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else
  {
    return (
      <React.Fragment>
        <SEO title="Accommodation | ICSI 2023" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"

        />
  
        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h3>Venus Royal Hotel Shenzhen Shajing Qilin(Shenzhen International Convention and Exhibition Center) [维纳斯皇家酒店(深圳国际会展中心店)]  &quot;!</h3>
            <div className="space-20"></div>

            <ol>
                <strong>
              <li>
              All participants are highly recommendated to make a reservation at Venus Royal Hotel Shenzhen Shajing Qilin(Shenzhen International Convention and Exhibition Center).
              </li>
                </strong>



              
                <strong>
              <li>
               You can check-in at the hotel reception on the afternoon of the 14th and mention that you are a participant of the International Conference on Swarm Intelligence to receive the special agreement price between our conference and the hotel. Additionally, you may request an invoice at the reception.
              </li>
                </strong>

                <strong>
              <li>
              If you have any questions about the room types or other custom needs, please contact Manager Luo at the hotel (Tel. +86-18677480814) for consultation.
              </li>
                </strong>
                <strong>
              <li>
              If you have any questions, please don&apos;t hesitate to contact us via email or in the WeChat group.
              </li>
                </strong>
            </ol>

            <div className="space-40"></div>


            <hr></hr>
            <div className="space-20"></div>

            <h3>About the venue hotel</h3>
            <br></br>
            Venus Royal Hotel Shenzhen Shajing Qilin(Shenzhen International Convention and Exhibition Center) [维纳斯皇家酒店(深圳国际会展中心店)] is located in the west of Shenzhen City, with convenient transportation, sea, land and air connections, close to exit b of Ma&apos;anshan station of Shenzhen Airport Metro Line 11, about 15 minutes&apos; walk; It&apos;s about 15 minutes&apos; drive from Fuyong Hong Kong Macao wharf and 4 kilometers from Shajing Exhibition Center. It&apos;s the core area of Shajing business district in Shenzhen, which is known as the &apos;hometown of delicious food&apos;. Around the shopping malls, there are Shajing Jingji Baina, Shajing Xinsha Tianhong and Jinsha fairy tale, all about 300 meters.
            <br></br>
          The nearby scenic spots are Fenghuangshan Forest Park in Shenzhen, one of the eight major forest parks planned to be built in Shenzhen. It is about 7km away from the hotel and 3.8km away from the sea pastoral tourism area; New exhibition center in Asia, about 3.8 km away from the hotel.
            <br></br>
          It was formerly known as Shenzhen Qilin Mountain View Hotel. It is close to mountains and rivers and has a beautiful environment. It covers an area of 16000 square meters with a total construction area of more than 100000 square meters. The hotel has all kinds of facilities, more than 400 kinds of warm guest rooms with complete facilities.
            <br></br>
          It has a luxurious pillarless banquet hall that can accommodate 1200 people at the same time, a multi-functional LED screen, seven meeting rooms for various business meetings, and a garden style free parking lot. Wudaoxiang cafeteria, lingnanhui seafood restaurant, zhongjihui private restaurant bring all kinds of food and wine. Swimming pool and other fitness and leisure facilities can meet the requirements of intelligent business, personalized social, leisure and vacation, and have become the flagship landmark buildings in the region.
          <br></br>
            <br></br>
          For more information about the hotel, please visit the website: <a className="simple-link" href="http://www.venusroyalhotel.com/">http://www.venusroyalhotel.com/</a>
          <br></br>
          <br></br>

          <table>
            <tr>
          <td width='50%'>
          <img
              src="./images/venue/hotel1.png"
              alt="hotel1"
              width="100%"
            />

          </td>
          <td width='50%'>
          <img
              src="./images/venue/hotel2.jpg"
              alt="hotel2"
              width="90%"
            />
          </td>
          </tr>
            <tr>
          <td width='50%'>
          <img
              src="./images/venue/hotel3.png"
              alt="hotel3"
              width="100%"
            />

          </td>
          <td width='50%'>
          <img
              src="./images/venue/hotel4.jpg"
              alt="hotel4"
              width="85%"
            />
          </td>
          </tr>
          </table>

            <div className="space-40"></div>


            <hr></hr>
            <div className="space-20"></div>



            {/* <h3>Other Recommended Hotels </h3>

            If you are not satisfied with the hotels listed above, you may choose to stay at a hotel near the conference venue on your own. Around the main conference venue, we recommend the following hotels:

            <ol>
              <li>维也纳酒店(深圳大学城店) - Vienna Hotel (Shenzhen University City Store)</li>
              <li>汉庭酒店(深圳西丽地铁站店) - Hanting Hotel (Shenzhen Xili Metro Station)</li>
              <li>深圳南山西丽大学城亚朵酒店 - Atour Hotel (Shenzhen Nanshan Xili University Town)</li>
            </ol> */}

            


            
          </div>

          <div>
          {/* <h2>The information is to be announced. </h2> */}

          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Accommodation;
